import React, { useState, useEffect, useContext, Fragment } from 'react';
import Traductor from '../Traductor';
import Input from '../bronson/Input';
import { VehiclesContext } from "../../contexts/VehiclesContext";
import SellService from "../../services/SellService";
import { withCookies } from 'react-cookie';
import Globals from '../../Globals';
import Loading from '../bronson/Loading';
import { UserContext } from '../../contexts/UserContext';

import "../../css/components/dealerReceptor/modalNegotiateVehicle.css";
import UserNegotiateIcon from '../../images/icons/user-negotiate-icon.png';
import errorTruckSvg from '../../images/icons//error-truck.svg';

function ModalNegotiateVehicle({ closeModal, cookies }) {

    const t = new Traductor();
    const { selectedVehicle } = useContext(VehiclesContext);
    const [ariaHidden, setAriaHidden] = useState("false");
    const [loading, setLoading] = useState(false);
    const [errorRequest, setRequestError] = useState(false);
    const [errorRequestMessage, setErrorRequestMessage] = useState(null);
    const [sended, setSended] = useState(false);
    const [negotiationPrice, setNegotiationPrice] = useState(""); //id del tipo precio por defecto
    const [reasonTypeSelected] = useState(10); //id del tipo precio por defecto
    const [reasonComment, setReasonComment] = useState("");
    const [errorPrice, setErrorPrice] = useState(false);
    const { user } = useContext(UserContext);

    useEffect(() => {
        if (!selectedVehicle)
            closeModal()
    }, []);

    const onChangeReason = (e) => {
        setReasonComment(e.target.value)
    }

    const onChangeNegotiationPrice = (e) => {
        let value = e.target.value;
        value = value.replace(/[^\d]/g, "");
        if (parseFloat(value) >= 0) setErrorPrice(false)
        else setErrorPrice(true)
        setNegotiationPrice(value);
    }

    const closeThisModal = () => {
        if (sended) closeModal("Delete");
        else closeModal();
    }

    const printTitle = () => {
        if (sended) {
            return (
                <Fragment>
                    <img src={UserNegotiateIcon} style={{ width: "200px" }}></img>
                    <h1 className="c-modal__title u-mt-xlarge" id="modal-negotiate-vehicle-title"> {t.getTraduction("ModalNegotiateVehicle_title_acepted")}</h1>
                </Fragment>
            )
        } else if (errorRequestMessage != null) {
            return (
                <Fragment>
                    <img src={errorTruckSvg} style={{ width: "200px" }}></img>
                    <h1 className="c-modal__title u-mt-xlarge" id="modal-negotiate-vehicle-title">{t.getTraduction("Oops")}</h1>
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <h1 className="c-modal__title" id="modal-negotiate-vehicle-title"> {t.getTraduction("Negotiate")}</h1>
                </Fragment>
            )
        }

    }

    const printInfoContainer = () => {
        if (sended) {
            return (
                <div className="c-modal__content u-pl u-pr u-pb-large u-pb-none@s" role="document">
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1 u-text-center">
                            <p>{t.getTraduction("ModalNegotiateVehicle_body_acepted")}</p>
                        </div>
                    </div>
                </div>
            )
        } else if (errorRequestMessage != null) {
            return (
                <div className="c-modal__content u-pl u-pr u-pb-large u-pb-none@s" role="document">
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1 u-text-center">
                            <p>{errorRequestMessage}</p>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="c-modal__content u-pt u-pb-large u-pb-none@s" role="document">
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1 u-text-center">
                            <p><strong>{t.getTraduction("ModalNegotiateVehicle_title")}</strong></p>
                            <p>{t.getTraduction("ModalNegotiateVehicle_subtitle")}</p>
                        </div>
                    </div>
                    <div className="u-mt-large">
                        <fieldset className="o-fieldset">
                            <div className="o-fieldset__row">
                                <div className="o-layout">
                                    <div className="o-layout__item  u-1/2">
                                        <Input
                                            onChange={(e) => onChangeNegotiationPrice(e)}
                                            value={negotiationPrice}
                                            options={{
                                                id: "modal-negotiate-vehicle-price",
                                                name: "modal-negotiate-vehicle-price",
                                                type: "number",
                                                event: true,
                                                label: t.getTraduction("Import"),
                                                showLabel: true,
                                                placeHolder: "",
                                                backLabel: "€",
                                                isRequired: true,
                                                className: (errorPrice ? "is-error" : ""),
                                                disabled: loading ? true : false
                                            }}
                                        ></Input>
                                    </div>
                                </div>
                            </div>
                            <div className="o-fieldset__row">
                                <div className="o-layout">
                                    <div className="o-layout__item  u-1/1">
                                        <div className="c-form-field">
                                            {t.getTraduction("Reason")}
                                            <div className="c-form-field__box">
                                                <div className="c-input c-input--textarea">
                                                    <textarea
                                                        className="c-input__input"
                                                        id="modal-negotiate-vehicle-comment"
                                                        cols="30"
                                                        rows="4"
                                                        placeholder=""
                                                        value={reasonComment}
                                                        onChange={(e) => onChangeReason(e)}
                                                        disabled={loading ? true : false}
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div >
            )
        }
    }

    const printFooterButtons = () => {
        let content = null;
        if (sended || errorRequestMessage != null) {
            content = (
                <div className="c-modal__actions__item">
                    <button className="c-btn c-btn--secondary js-modal-close" disabled={loading ? true : false} aria-label="Cerrar" onClick={() => closeThisModal()}>
                        <span className="c-btn__text">
                            {t.getTraduction("Close")}
                        </span>
                    </button>
                </div>
            )
        } else {
            content = (
                <Fragment>
                    <div className="c-modal__actions__item">
                        <button className="c-btn c-btn--secondary js-modal-close" disabled={loading ? true : false} aria-label="Volver atrás" onClick={() => closeModal("Prev")}>
                            <span className="c-btn__text">
                                {t.getTraduction("Back")}
                            </span>
                        </button>
                    </div>
                    <div className="c-modal__actions__item">
                        <button className="c-btn js-modal-close js-modal-autofocus" disabled={loading ? true : false} aria-label="Desestimar vehiculo" onClick={validate}>
                            <span className="c-btn__text">
                                {t.getTraduction("StartNegotiation")}
                            </span>
                        </button>
                    </div>
                </Fragment>
            )
        }
        if (content == null) return null;
        return (
            <div className="c-modal__footer">
                {errorRequest ?
                    <p className="c-error-message u-text-center u-mb">
                        {t.getTraduction("RequestErrorMessage")}
                    </p>
                    : null
                }
                <div className="c-modal__actions">
                    {content}
                </div>
            </div>
        )
    }

    const validate = () => {
        if (selectedVehicle.RepurchaseObligation == 2) {
            if (parseFloat(negotiationPrice) >= 0) {
                setErrorPrice(false)
                save();
            } else {
                setErrorPrice(true)
            }
        } else save();
    }

    const save = async () => {
        setLoading(true);
        setRequestError(false);

        let data = {
            Vehicle: selectedVehicle,
            CounterOfferPrice: negotiationPrice,
            NotBuyType: reasonTypeSelected,
            Observations: reasonComment,
            ProfileId: user.data.Profile,
            EmployeId: user.data.Empleado.Id,
            CIF: user.data.DocumentId
        }
        await new SellService().negotiateVehicle(data, cookies.get(Globals.COOKIES.JWT).AccessToken).then(
            response => {
                if (response && response.statusCode == 200 && response.body.Result != null && response.body.Result == "true") {
                    setSended(true);
                } else {
                    if (response && response.body && response.body.Errors && response.body.Errors.length > 0) {
                        setErrorRequestMessage(response.body.Errors[0].Value);
                    }
                    else {
                        setRequestError(true)
                    }
                }
            }
        );
        setLoading(false);
    };

    return (
        <Fragment>
            <div className="c-modal" aria-hidden={ariaHidden} id="modal-negotiate-vehicle">
                <div className="c-modal__overlay  js-modal-close" tabIndex="-1"></div>
                <div className="c-modal__wrapper" role="dialog" aria-labelledby="modal-negotiate-vehicle-title">
                    <header className="c-modal__header">
                        <button className="c-modal__close-btn  js-modal-close" type="button" aria-label="Cerrar modal." onClick={closeThisModal}></button>
                        <div className="c-modal__title__wrapper">
                            {printTitle()}
                        </div>
                    </header>
                    {printInfoContainer()}
                    {printFooterButtons()}
                </div>
            </div>
            <Loading ariaBusy={loading} ></Loading>
        </Fragment>
    );
}

export default withCookies(ModalNegotiateVehicle);